import script from "./UsersDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersDetail.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__